import { Badge } from '@nexelem/components';
import { selectDefaultView, useSaveViewStore } from '.';
import { useTableName } from '../utils';
import { openSavedViewsDrawer } from './SavedViewsDrawer';

export const ViewBadge = () => {
  const tableName = useTableName();
  const defaultView = useSaveViewStore(selectDefaultView(tableName));

  if (!defaultView) {
    return null;
  }

  return (
    <Badge className="cursor-pointer" variant="highlighted" onClick={openSavedViewsDrawer}>
      {defaultView.name}
    </Badge>
  );
};
